module.exports = __webpack_public_path__ + "static/annes-hand-c0f5c28c115efa8cdaff39069f9002fb.jpg";